// 견적 액션(rpc) — 편집기의 저장·자동저장·초안 버리기·단가 추천·일정 생성·가견적 저장.
import { rpc } from "@/api/client";
import type { VatMode } from "@buildpy/core/modules/money/vat";

export const saveQuoteDraft = (quoteId: string, draft: unknown, baseRev: number, force = false) =>
  rpc("quote/actions/saveQuoteDraft", quoteId, draft, baseRev, force);

export const autosaveQuoteDraft = (quoteId: string, draft: unknown, baseRev: number) =>
  rpc("quote/actions/autosaveQuoteDraft", quoteId, draft, baseRev);

export const discardQuoteDraft = (quoteId: string, expectSavedAt?: string) => rpc("quote/actions/discardQuoteDraft", quoteId, expectSavedAt);

// vatMode = 견적의 단가 방식 — 단가표(공급가 기준)를 그 방식으로 바꿔 받는다 · 비우면 포함.
export const getPriceSuggestion = (trade: string, scope: string, item: string, unit: string, vatMode?: VatMode) =>
  rpc("quote/actions/getPriceSuggestion", trade, scope, item, unit, vatMode);

export const searchPriceSuggestions = (trade: string, keyword: string, vatMode?: VatMode) =>
  rpc("quote/actions/searchPriceSuggestions", trade, keyword, vatMode);

export const generateQuoteSchedule = (input: unknown) => rpc("quote/actions/generateQuoteSchedule", input);

export const saveRoughQuote = (quoteId: string, input: unknown, baseRev: number) => rpc("quote/actions/saveRoughQuote", quoteId, input, baseRev);

export const sendQuote = (quoteId: string, input: unknown, force = false) => rpc("quote/actions/sendQuote", quoteId, input, force);

// 발송 뒤 고른 새 품목을 단가표에 넣는다 — 있는 키는 건너뛴다.
export const savePriceCandidates = (quoteId: string, keys: string[]) => rpc("quote/actions/savePriceCandidates", quoteId, keys);

export const decideQuote = (quoteId: string, decision: unknown, lostReason?: string | null) =>
  rpc("quote/actions/decideQuote", quoteId, decision, lostReason);

export const createNewVersion = (quoteId: string) => rpc("quote/actions/createNewVersion", quoteId);

// 손익(내부) 탭의 실제 원가 — 공종 코드마다 금액(비우면 지움)·메모.
export const saveActualCosts = (quoteId: string, rows: { trade: string; amount: number | null; memo: string | null }[]) =>
  rpc("quote/profit-actions/saveActualCosts", quoteId, rows);
